"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ModalContext_1 = tslib_1.__importDefault(require("../Modal/ModalContext"));
const ModalContextProvider = ({ children }) => {
    const [currentModalZIndex, setCurrentModalZIndex] = React.useState(100);
    const value = { currentModalZIndex, setCurrentModalZIndex };
    return (React.createElement(ModalContext_1.default.Provider, { value: value }, children));
};
exports.default = ModalContextProvider;
